import DashboardIcon from '@mui/icons-material/SpaceDashboardOutlined';
import InboxIcon from '@mui/icons-material/MoveToInboxOutlined';
import ArticleIcon from '@mui/icons-material/ArticleOutlined';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibraryOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

export interface AdminNavItem {
  key: string;
  to: string;
  Icon: SvgIconComponent;
  /** Route is only shown to users with one of these roles. */
  roles?: Array<'ADMIN' | 'EDITOR'>;
}

export const ADMIN_NAV: AdminNavItem[] = [
  { key: 'dashboard', to: '/admin/dashboard', Icon: DashboardIcon },
  { key: 'leads', to: '/admin/leads', Icon: InboxIcon },
  { key: 'projects', to: '/admin/projects', Icon: PhotoLibraryIcon },
  { key: 'content', to: '/admin/content', Icon: ArticleIcon },
  { key: 'settings', to: '/admin/settings', Icon: SettingsIcon },
  { key: 'users', to: '/admin/users', Icon: PeopleIcon, roles: ['ADMIN'] },
];

export const DRAWER_WIDTH = 252;
